import { c as canUseDom } from "./can-use-dom.js";
let passiveSupported = false;
if (canUseDom) {
  try {
    const opts = Object.defineProperty({}, "passive", {
      get() {
        passiveSupported = true;
      }
    });
    window.addEventListener("test-passive-supported", null, opts);
  } catch (e) {
    console.log(e);
  }
}
export {
  passiveSupported as p
};
